
import React from "react";

// reactstrap components
import { Button, Container } from "reactstrap";

// core components

function LandingPageHeader() {
  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth < 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });

  return (
    <>
      <div
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
          minHeight: '60vh',
          paddingTop: '120px',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center'
        }}
        className="page-header"
        data-parallax={true}
        ref={pageHeader}
      >
        <div className="filter" style={{
          background: 'rgba(0,0,0,0.1)',
          backdropFilter: 'blur(1px)'
        }} />
        <Container>
          <div className="motto text-center">
            <div style={{
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '30px',
              padding: '60px 40px',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.2)',
              boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
            }}>
              <h1 style={{
                background: 'linear-gradient(45deg, #ff6b6b, #feca57, #4facfe)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontSize: '4rem',
                fontWeight: '900',
                marginBottom: '20px',
                textShadow: '0 4px 8px rgba(0,0,0,0.3)'
              }}>
                <b>Contact</b>
              </h1>
              
              <div style={{
                width: '120px',
                height: '4px',
                background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                margin: '0 auto 30px',
                borderRadius: '2px'
              }}></div>
              
              <h3 style={{
                color: 'rgba(255,255,255,0.95)',
                fontSize: '2rem',
                fontWeight: '600',
                marginBottom: '40px',
                textShadow: '0 2px 4px rgba(0,0,0,0.3)'
              }}>
                Let's have a chat
              </h3>
              
              <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <Button
                  href="https://wa.me/+96181906656"
                  target="_blank"
                  className="btn-round"
                  style={{
                    background: 'linear-gradient(45deg, #25d366, #128c7e)',
                    border: 'none',
                    padding: '18px 40px',
                    borderRadius: '30px',
                    color: 'white',
                    fontWeight: '700',
                    fontSize: '1.2rem',
                    boxShadow: '0 10px 30px rgba(37, 211, 102, 0.4)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.05)';
                    e.target.style.boxShadow = '0 15px 40px rgba(37, 211, 102, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = '0 10px 30px rgba(37, 211, 102, 0.4)';
                  }}
                >
                  <i className="fa fa-whatsapp" style={{ marginRight: '10px' }} />
                  WhatsApp
                </Button>
                
                <Button 
                  className="btn-round"
                  style={{
                    background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                    border: 'none',
                    padding: '18px 40px',
                    borderRadius: '30px',
                    color: 'white',
                    fontWeight: '700',
                    fontSize: '1.2rem',
                    boxShadow: '0 10px 30px rgba(255, 107, 107, 0.4)',
                    transition: 'all 0.3s ease'
                  }}
                  href="https://tawk.to/60d3a9667f4b000ac0393950"
                  target="_blank"
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.05)';
                    e.target.style.boxShadow = '0 15px 40px rgba(255, 107, 107, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = '0 10px 30px rgba(255, 107, 107, 0.4)';
                  }}
                >
                  <i className="fa fa-comments" style={{ marginRight: '10px' }} />
                  Live Chat
                </Button>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}

export default LandingPageHeader;
